// Alerts
export const SET_ALERT = 'SET_ALERT';
export const REMOVE_ALERT = 'REMOVE_ALERT';

// Breadcrumb
export const EDITAR_BREADCRUMB = 'EDITAR_BREADCRUMB';

// Loader
export const SHOW_LOADER = 'SHOW_LOADER';
export const HIDE_LOADER = 'HIDE_LOADER';

// Auth
export const LOGIN = 'LOGIN';
export const LOGIN_ERROR = 'LOGIN_ERROR';
export const OBTENER_USUARIO = 'OBTENER_USUARIO';
export const OBTENER_USUARIO_ERROR = 'OBTENER_USUARIO_ERROR';
export const LOGOUT = 'LOGOUT';
export const RECUPERAR_USUARIO = 'RECUPERAR_USUARIO';
export const RESTABLECER_USUARIO = 'RESTABLECER_USUARIO';

// Dashboard
export const DASHBOARD = {
    OBTENER: 'OBTENER_DASHBOARD',

    PROYECTOS_ACTIVOS_CARGANDO: 'DASHBOARD_PROYECTOS_ACTIVOS_CARGANDO',
    PROYECTOS_ACTIVOS: 'DASHBOARD_PROYECTOS_ACTIVOS',
    PROYECTOS_ACTIVOS_ERROR: 'DASHBOARD_PROYECTOS_ACTIVOS_ERROR',

    VENTAS_PERIODOS_CARGANDO: 'DASHBOARD_VENTAS_PERIODOS_CARGANDO',
    VENTAS_PERIODOS: 'DASHBOARD_VENTAS_PERIODOS',
    VENTAS_PERIODOS_ERROR: 'DASHBOARD_VENTAS_PERIODOS_ERROR',

    VENTAS_30_DIAS_CARGANDO: 'DASHBOARD_VENTAS_30_DIAS_CARGANDO',
    VENTAS_30_DIAS: 'DASHBOARD_VENTAS_30_DIAS',
    VENTAS_30_DIAS_ERROR: 'DASHBOARD_VENTAS_30_DIAS_ERROR',

    POR_COBRAR_CARGANDO: 'DASHBOARD_POR_COBRAR_CARGANDO',
    POR_COBRAR: 'DASHBOARD_POR_COBRAR',
    POR_COBRAR_ERROR: 'DASHBOARD_POR_COBRAR_ERROR'
};

// Usuarios
export const USUARIO = {
    BUSCAR: 'BUSCAR_USUARIOS', 
    AGREGAR: 'AGREGAR_USUARIO', 
    DETALLES: 'DETALLES_USUARIO', 
    EDITAR: 'EDITAR_USUARIO', 
    ELIMINAR: 'ELIMINAR_USUARIO', 
    FILTROS: 'FILTRAR_USUARIOS'
};

// Proveedores
export const PROVEEDOR = {
    BUSCAR: 'BUSCAR_PROVEEDORES', 
    AGREGAR: 'AGREGAR_PROVEEDOR', 
    DETALLES: 'DETALLES_PROVEEDOR', 
    EDITAR: 'EDITAR_PROVEEDOR', 
    ELIMINAR: 'ELIMINAR_PROVEEDOR', 
    PRODUCTOS_BUSCAR: 'PROVEEDOR_PRODUCTOS_BUSCAR',
    PRODUCTOS_DETALLES: 'PROVEEDOR_PRODUCTOS_DETALLES',
    PRODUCTOS_EDITAR: 'PROVEEDOR_PRODUCTOS_EDITAR',
    PRODUCTOS_ELIMINAR: 'PROVEEDOR_PRODUCTOS_ELIMINAR',
    //FILTROS: 'FILTRAR_PROVEEDORES'
};

//Categorías
export const CONFIGURACION_CATEGORIAS = {
    BUSCAR: 'BUSCAR_CATEGORIAS', 
    AGREGAR: 'AGREGAR_CATEGORIA', 
    DETALLES: 'DETALLES_CATEGORIA', 
    EDITAR: 'EDITAR_CATEGORIA', 
    ELIMINAR: 'ELIMINAR_CATEGORIA'
};

export const CONFIGURACION_SUBCATEGORIAS = {
    BUSCAR: 'BUSCAR_SUBCATEGORIAS', 
    AGREGAR: 'AGREGAR_SUBCATEGORIA', 
    DETALLES: 'DETALLES_SUBCATEGORIA', 
    EDITAR: 'EDITAR_SUBCATEGORIA', 
    ELIMINAR: 'ELIMINAR_SUBCATEGORIA'
};

export const CONFIGURACION_PRODUCTOS = {
    FILTROS: 'FILTROS_PRODUCTOS', 
    BUSCAR: 'BUSCAR_PRODUCTOS', 
    AGREGAR: 'AGREGAR_PRODUCTO', 
    DETALLES: 'DETALLES_PRODUCTO', 
    EDITAR: 'EDITAR_PRODUCTO', 
    ELIMINAR: 'ELIMINAR_PRODUCTO', 
    ELIMINAR_MULTIPLE: 'ELIMINAR_PRODUCTOS',
    CODIGO_SIGUIENTE: 'CODIGO_SIGUIENTE_PRODUCTO'
};

// Configuración
export const CONFIGURACION_PERFIL = {
    EDITAR_PERSONAL: 'EDITAR_PERFIL_PERSONAL', 
    EDITAR_EMPRESARIAL: 'EDITAR_PERFIL_EMPRESARIAL'
};

//Areas
export const CONFIGURACION_AREAS = {
    BUSCAR:  'BUSCAR_AREAS',
    AGREGAR: 'AGREGAR_AREA',
    EDITAR:  'EDITAR_AREA',      
    ELIMINAR:'ELIMINAR_AREA',
    DETALLES:'DETALLES_ELIMINAR'
};

//Organizadores
export const CONFIGURACION_ORGANIZADORES = {
    BUSCAR:   'BUSCAR_ORGANIZADORES',
    AGREGAR:  'AGREGAR_ORGANIZADOR',
    DETALLES: 'DETALLES_ORGANIZADOR',
    EDITAR:   'EDITAR_ORGANIZADOR',
    ELIMINAR: 'ELIMINAR_ORGANIZADOR'
};

//Ubicaciones
export const CONFIGURACION_UBICACIONES = {
    BUSCAR:   'BUSCAR_UBICACIONES',
    AGREGAR:  'AGREGAR_UBICACION',
    DETALLES: 'DETALLES_UBICACION',
    EDITAR:   'EDITAR_UBICACION',
    ELIMINAR: 'ELIMINAR_UBICACION'
};

// Proveedores por producto
export const CONFIGURACION_PROVEEDORES_PRODUCTO = {
    BUSCAR:  'BUSCAR_PROVEEDORES_PRODUCTO',
    LIMPIAR: 'LIMPIAR_PROVEEDORES_PRODUCTO',
    ERROR:   'ERROR_PROVEEDORES_PRODUCTO'
};

//Métodos
export const CONFIGURACION_METODOS_PAGO = {
    BUSCAR: 'BUSCAR_METODOS_PAGO',
    AGREGAR: 'AGREGAR_METODO_PAGO',
    DETALLES: 'DETALLES_METODO_PAGO',
    EDITAR: 'EDITAR_METODO_PAGO',
    ELIMINAR: 'ELIMINAR_METODO_PAGO'
};


//Facturas
export const FACTURA = {
    BUSCAR: 'FACTURA_BUSCAR',
    FILTRAR: 'FACTURA_FILTRAR',
    LIMPIAR: 'FACTURA_LIMPIAR',
    SET_FILTROS: 'FACTURA_SET_FILTROS',
    LIMPIAR_FILTROS: 'FACTURA_LIMPIAR_FILTROS',
    CREAR: 'FACTURA_CREAR',
    CREAR_ERROR: 'FACTURA_CREAR_ERROR',
    DETALLE: 'FACTURA_DETALLE',
    LIMPIAR_DETALLE: 'FACTURA_LIMPIAR_DETALLE',
    EDITAR: 'FACTURA_EDITAR',
    EDITAR_ERROR: 'FACTURA_EDITAR_ERROR',
    ERROR: 'FACTURA_ERROR',
    CATEGORIAS_CARGADAS: 'FACTURAS_CATEGORIAS_CARGADAS',
    SUBCATEGORIAS_CARGADAS: 'FACTURAS_SUBCATEGORIAS_CARGADAS',
    PRODUCTOS_CARGADOS : 'FACTURAS_PRODUCTOS_CARGADOS',
    SUBCATEGORIAS_NUEVO_PRODUCTO_CARGADAS: 'FACTURAS_SUBCATEGORIAS_NUEVO_PRODUCTO_CARGADAS',
    PRODUCTO_CREADO: 'FACTURAS_PRODUCTO_CREADO',
    CODIGO_PRODUCTO_CARGADO: 'FACTURA_CODIGO_PRODUCTO_CARGADO',
    LIMPIAR_CODIGO_PRODUCTO: 'FACTURA_LIMPIAR_CODIGO_PRODUCTO',
    LIMPIAR_CATALOGOS: 'FACTURA_LIMPIAR_CATALOGOS',
    ELIMINAR: 'FACTURA_ELIMINAR',
    ELIMINAR_ERROR: 'FACTURA_ELIMINAR_ERROR',
    DEVOLVER: 'FACTURA_DEVOLVER',
    DEVOLVER_ERROR: 'FACTURA_DEVOLVER_ERROR',
    DETALLE_DEVOLUCION: 'FACTURA_DETALLE_DEVOLUCION',
    LIMPIAR_DETALLE_DEVOLUCION: 'FACTURA_LIMPIAR_DETALLE_DEVOLUCION',
    DEVOLVER_PARCIAL: 'FACTURA_DEVOLVER_PARCIAL',
    DEVOLVER_PARCIAL_ERROR: 'FACTURA_DEVOLVER_PARCIAL_ERROR'
};

export const CONFIGURACION_UNIDADES = {
    BUSCAR: 'BUSCAR_UNIDADES',
    LIMPIAR: 'LIMPIAR_UNIDADES',
    CREAR: 'CREAR_UNIDAD',
    CREAR_ERROR: 'CREAR_UNIDAD_ERROR',
    EDITAR: 'EDITAR_UNIDAD',
    EDITAR_ERROR: 'EDITAR_UNIDAD_ERROR',
    ELIMINAR: 'ELIMINAR_UNIDAD',
    ELIMINAR_ERROR: 'ELIMINAR_UNIDAD_ERROR',
    ERROR: 'ERROR_UNIDADES'
};

export const CONFIGURACION_PAQUETES = {
    BUSCAR: 'BUSCAR_PAQUETES',
    LIMPIAR: 'LIMPIAR_PAQUETES',
    DETALLE: 'DETALLE_PAQUETE',
    LIMPIAR_DETALLE: 'LIMPIAR_DETALLE_PAQUETE',
    CREAR: 'CREAR_PAQUETE',
    CREAR_ERROR: 'CREAR_PAQUETE_ERROR',
    EDITAR: 'EDITAR_PAQUETE',
    EDITAR_ERROR: 'EDITAR_PAQUETE_ERROR',
    ELIMINAR: 'ELIMINAR_PAQUETE',
    ELIMINAR_ERROR: 'ELIMINAR_PAQUETE_ERROR',
    ERROR: 'ERROR_PAQUETES'
};

//Inventario
export const INVENTARIO = {
    LISTAR: 'INVENTARIO_LISTAR',
    LIMPIAR: 'INVENTARIO_LIMPIAR',
    ERROR: 'INVENTARIO_ERROR',

    CATEGORIAS_CARGADAS: 'INVENTARIO_CATEGORIAS_CARGADAS',
    SUBCATEGORIAS_CARGADAS: 'INVENTARIO_SUBCATEGORIAS_CARGADAS',
    PROVEEDORES_CARGADOS: 'INVENTARIO_PROVEEDORES_CARGADOS',

    SET_FILTROS: 'INVENTARIO_SET_FILTROS',
    LIMPIAR_FILTROS: 'INVENTARIO_LIMPIAR_FILTROS',

    DETALLES: 'INVENTARIO_DETALLES',
    LIMPIAR_DETALLES: 'INVENTARIO_LIMPIAR_DETALLES',

    PROVEEDORES_PRODUCTO_CARGANDO: 'INVENTARIO_PROVEEDORES_PRODUCTO_CARGANDO',
    PROVEEDORES_PRODUCTO_CARGADOS: 'INVENTARIO_PROVEEDORES_PRODUCTO_CARGADOS',
    PROVEEDORES_PRODUCTO_ERROR: 'INVENTARIO_PROVEEDORES_PRODUCTO_ERROR',
    LIMPIAR_PROVEEDORES_PRODUCTO: 'INVENTARIO_LIMPIAR_PROVEEDORES_PRODUCTO',

    MOVIMIENTOS_LISTAR: 'INVENTARIO_MOVIMIENTOS_LISTAR',
    MOVIMIENTOS_LIMPIAR: 'INVENTARIO_MOVIMIENTOS_LIMPIAR',
    MOVIMIENTOS_ERROR: 'INVENTARIO_MOVIMIENTOS_ERROR',

    MOVIMIENTOS_AREAS_CARGADAS: 'INVENTARIO_MOVIMIENTOS_AREAS_CARGADAS',

    MOVIMIENTOS_ORGANIZADORES_ORIGEN_CARGADOS: 'INVENTARIO_MOVIMIENTOS_ORGANIZADORES_ORIGEN_CARGADOS',
    MOVIMIENTOS_UBICACIONES_ORIGEN_CARGADAS: 'INVENTARIO_MOVIMIENTOS_UBICACIONES_ORIGEN_CARGADAS',

    MOVIMIENTOS_ORGANIZADORES_DESTINO_CARGADOS: 'INVENTARIO_MOVIMIENTOS_ORGANIZADORES_DESTINO_CARGADOS',
    MOVIMIENTOS_UBICACIONES_DESTINO_CARGADAS: 'INVENTARIO_MOVIMIENTOS_UBICACIONES_DESTINO_CARGADAS',

    MOVIMIENTOS_PRODUCTOS_ORIGEN_CARGADOS: 'INVENTARIO_MOVIMIENTOS_PRODUCTOS_ORIGEN_CARGADOS',
    MOVIMIENTOS_LIMPIAR_FORM: 'INVENTARIO_MOVIMIENTOS_LIMPIAR_FORM',
    MOVIMIENTOS_CREADO: 'INVENTARIO_MOVIMIENTOS_CREADO'
};

//Clientes
export const CLIENTES = {
    LISTAR: 'CLIENTES_LISTAR',
    LIMPIAR: 'CLIENTES_LIMPIAR',
    ERROR: 'CLIENTES_ERROR',

    DETALLES_CARGANDO: 'CLIENTES_DETALLES_CARGANDO',
    DETALLES: 'CLIENTES_DETALLES',
    LIMPIAR_DETALLES: 'CLIENTES_LIMPIAR_DETALLES'
};

//Ventas
export const VENTAS = {
    CLIENTES_BUSCAR: 'VENTAS_CLIENTES_BUSCAR',
    CLIENTES_LIMPIAR: 'VENTAS_CLIENTES_LIMPIAR',
    CLIENTE_CREADO: 'VENTAS_CLIENTE_CREADO',

    METODOS_LISTAR: 'VENTAS_METODOS_LISTAR',

    PRODUCTOS_LISTAR: 'VENTAS_PRODUCTOS_LISTAR',
    PRODUCTOS_LIMPIAR: 'VENTAS_PRODUCTOS_LIMPIAR',

    CATEGORIAS_CARGADAS: 'VENTAS_CATEGORIAS_CARGADAS',
    SUBCATEGORIAS_CARGADAS: 'VENTAS_SUBCATEGORIAS_CARGADAS',

    INVENTARIO_PRODUCTOS_LISTAR: 'VENTAS_INVENTARIO_PRODUCTOS_LISTAR',
    INVENTARIO_PRODUCTOS_LIMPIAR: 'VENTAS_INVENTARIO_PRODUCTOS_LIMPIAR',

    DETALLE_PRODUCTO: 'VENTAS_DETALLE_PRODUCTO',
    LIMPIAR_DETALLE_PRODUCTO: 'VENTAS_LIMPIAR_DETALLE_PRODUCTO',

    VENTA_CREADA: 'VENTAS_VENTA_CREADA',
    LIMPIAR_VENTA: 'VENTAS_LIMPIAR_VENTA',

    ERROR: 'VENTAS_ERROR',

    LISTAR_VENTAS_CARGANDO: 'VENTAS_LISTAR_VENTAS_CARGANDO',
    LISTAR_VENTAS: 'VENTAS_LISTAR_VENTAS',

    DETALLES_VENTA_CARGANDO: 'VENTAS_DETALLES_VENTA_CARGANDO',
    DETALLES_VENTA: 'VENTAS_DETALLES_VENTA',
    LIMPIAR_DETALLES_VENTA: 'VENTAS_LIMPIAR_DETALLES_VENTA',

    DETALLES_EDITAR: 'VENTAS_DETALLES_EDITAR',
    LIMPIAR_DETALLES_EDITAR: 'VENTAS_LIMPIAR_DETALLES_EDITAR',
    EDITAR_OK: 'VENTAS_EDITAR_OK',

    DEVOLUCIONES_LISTAR: 'VENTAS_DEVOLUCIONES_LISTAR',
};

//Carga de inventario existente
export const INVENTARIO_CARGA = {
    LISTADO_CARGANDO: 'INVENTARIO_CARGA_LISTADO_CARGANDO',
    LISTADO_CARGADO: 'INVENTARIO_CARGA_LISTADO_CARGADO',
    LISTADO_ERROR: 'INVENTARIO_CARGA_LISTADO_ERROR',

    GUARDANDO: 'INVENTARIO_CARGA_GUARDANDO',
    GUARDADO_OK: 'INVENTARIO_CARGA_GUARDADO_OK',
    GUARDADO_ERROR: 'INVENTARIO_CARGA_GUARDADO_ERROR',

    PENDIENTE_AGREGAR: 'INVENTARIO_CARGA_PENDIENTE_AGREGAR',
    PENDIENTE_ACTUALIZAR: 'INVENTARIO_CARGA_PENDIENTE_ACTUALIZAR',
    PENDIENTE_QUITAR: 'INVENTARIO_CARGA_PENDIENTE_QUITAR',
    PENDIENTES_LIMPIAR: 'INVENTARIO_CARGA_PENDIENTES_LIMPIAR'
};

//Proyectos
export const PROYECTOS = {
    LISTAR: 'PROYECTOS_LISTAR',
    FILTRAR: 'PROYECTOS_FILTRAR',
    LIMPIAR: 'PROYECTOS_LIMPIAR',
    SET_FILTROS: 'PROYECTOS_SET_FILTROS',
    LIMPIAR_FILTROS: 'PROYECTOS_LIMPIAR_FILTROS',
    ERROR: 'PROYECTOS_ERROR',

    DETALLE_CARGANDO: 'PROYECTOS_DETALLE_CARGANDO',
    DETALLE: 'PROYECTOS_DETALLE',
    LIMPIAR_DETALLE: 'PROYECTOS_LIMPIAR_DETALLE',

    RESUMEN_CARGANDO: 'PROYECTOS_RESUMEN_CARGANDO',
    RESUMEN: 'PROYECTOS_RESUMEN',
    LIMPIAR_RESUMEN: 'PROYECTOS_LIMPIAR_RESUMEN'
};

//Cotizaciones (proyectos)
export const COTIZACIONES = {
    LISTAR: 'COTIZACIONES_LISTAR',
    FILTRAR: 'COTIZACIONES_FILTRAR',
    LIMPIAR: 'COTIZACIONES_LIMPIAR',
    ERROR: 'COTIZACIONES_ERROR',

    DETALLE_CARGANDO: 'COTIZACIONES_DETALLE_CARGANDO',
    DETALLE: 'COTIZACIONES_DETALLE',
    LIMPIAR_DETALLE: 'COTIZACIONES_LIMPIAR_DETALLE'
};

//Conceptos externos (proyectos)
export const CONCEPTOS_EXTERNOS = {
    LISTAR: 'CONCEPTOS_EXTERNOS_LISTAR',
    FILTRAR: 'CONCEPTOS_EXTERNOS_FILTRAR',
    LIMPIAR: 'CONCEPTOS_EXTERNOS_LIMPIAR',
    ERROR: 'CONCEPTOS_EXTERNOS_ERROR'
};

//Ordenes de salida (proyectos)
export const ORDENES_SALIDA = {
    LISTAR: 'ORDENES_SALIDA_LISTAR',
    FILTRAR: 'ORDENES_SALIDA_FILTRAR',
    LIMPIAR: 'ORDENES_SALIDA_LIMPIAR',
    ERROR: 'ORDENES_SALIDA_ERROR',

    DETALLE_CARGANDO: 'ORDENES_SALIDA_DETALLE_CARGANDO',
    DETALLE: 'ORDENES_SALIDA_DETALLE',
    LIMPIAR_DETALLE: 'ORDENES_SALIDA_LIMPIAR_DETALLE'
};

//Ordenes de devolucion (proyectos)
export const ORDENES_DEVOLUCION = {
    LISTAR: 'ORDENES_DEVOLUCION_LISTAR',
    FILTRAR: 'ORDENES_DEVOLUCION_FILTRAR',
    LIMPIAR: 'ORDENES_DEVOLUCION_LIMPIAR',
    ERROR: 'ORDENES_DEVOLUCION_ERROR',

    DETALLE_CARGANDO: 'ORDENES_DEVOLUCION_DETALLE_CARGANDO',
    DETALLE: 'ORDENES_DEVOLUCION_DETALLE',
    LIMPIAR_DETALLE: 'ORDENES_DEVOLUCION_LIMPIAR_DETALLE',

    INVENTARIO_ENTREGADO_CARGANDO: 'ORDENES_DEVOLUCION_INVENTARIO_ENTREGADO_CARGANDO',
    INVENTARIO_ENTREGADO: 'ORDENES_DEVOLUCION_INVENTARIO_ENTREGADO',
    LIMPIAR_INVENTARIO_ENTREGADO: 'ORDENES_DEVOLUCION_LIMPIAR_INVENTARIO_ENTREGADO'
};

//Pagos de proyectos
export const PAGOS_PROYECTOS = {
    LISTAR: 'PAGOS_PROYECTOS_LISTAR',
    FILTRAR: 'PAGOS_PROYECTOS_FILTRAR',
    LIMPIAR: 'PAGOS_PROYECTOS_LIMPIAR',
    ERROR: 'PAGOS_PROYECTOS_ERROR'
};

//Pagos de ventas (clientes)
export const PAGOS_VENTAS = {
    ERROR: 'PAGOS_VENTAS_ERROR',

    BALANCE_CARGANDO: 'PAGOS_VENTAS_BALANCE_CARGANDO',
    BALANCE: 'PAGOS_VENTAS_BALANCE',
    LIMPIAR_BALANCE: 'PAGOS_VENTAS_LIMPIAR_BALANCE'
};


